import { useCallback, useState } from "react";
import BasicButton from "../../components/BasicButton";
import GalleryImage from "../../components/GalleryImage";
import { uploadToGallery, useGallery } from "../../misc/lib/gallery";

const GalleryAdminPanel = () => {
  const images = useGallery();
  const [ uploading, setUploading ] = useState(false);

  const doUploadGalleryImage = useCallback(() => {
    setUploading(true);

    const inputElement = document.createElement('input');
    inputElement.type = 'file'; inputElement.accept = 'image/*';
    inputElement.style.display = 'none'; inputElement.multiple = true;
    inputElement.onchange = () => {
      const tasks: Promise<void>[] = [];
      for (let i = 0; i < inputElement.files!.length; i++) {
        tasks.push(uploadToGallery(inputElement.files![ i ]));
      }

      Promise.all(tasks).catch((err) => {
        console.error(err);
      }).finally(() => {
        setUploading(false); inputElement.remove();
      });
    };

    document.body.appendChild(inputElement);
    inputElement.click();
  }, []);

  return (
    <div className="adminpage-gallery-panel">
      <BasicButton text="Új kép feltöltése" type="primary"
        onClick={ doUploadGalleryImage } working={ uploading } />
      <div className="adminpage-gallery-list">
        { images.map((img, i) => (
          <GalleryImage key={ i } { ...img } />
        )) }
      </div>
    </div>
  );
};

export default GalleryAdminPanel;
